module.exports = __webpack_public_path__ + "static/media/dzoks.c1c4eeab.jpg";